import React from 'react';
import miniHandlebars from '@tmap/mmm-core/miniHandlebars';
import DatePickerField from '@tmap/mmm-style-guide/src/fields/DatePickerField';
import generateValidator from '@tmap/mmm-core/commonApp/generateValidator';
import NumberField from '@tmap/mmm-style-guide/src/fields/NumberField';
import CheckboxField from '@tmap/mmm-style-guide/src/fields/CheckboxField';
import isEmptyish from '@tmap/mmm-core/isEmptyish';
import TextFieldField from '@tmap/mmm-style-guide/src/fields/TextFieldField';
import SelectField from '@tmap/mmm-style-guide/src/fields/SelectField';
import SliderField from '@tmap/mmm-style-guide/src/fields/SliderField';
import CheckboxesField from '@tmap/mmm-style-guide/src/fields/CheckboxesField';
import { KeyOutlined, ChairOutlined, NotListedLocationOutlined } from '@tmap/mmm-style-guide/src/Icon';
import { NotifPrefs } from '@tmap/mmm-core/notifPrefs';
import { useForm } from '@tmap/mmm-style-guide/src/final-form/react';
import isSimpleObject from '@tmap/mmm-core/isSimpleObject';

const typeToComponent = (type) => {
  switch (type) {
    case 'checkbox':
      return CheckboxField;
    case 'textbox':
      return TextFieldField;
    case 'select':
      return SelectField;
    case 'slider':
      return SliderField;
    case 'date':
      return DatePickerField;
    case 'number':
      return NumberField;
    case 'multiselect':
      return CheckboxesField;
    default:
      return null;
  }
};

function InputController(props) {
  const {
    WrappedComponent,
    inputController,
    input,
    ...rest
  } = props;
  const form = useForm();
  return (
    <WrappedComponent input={inputController(input, form.getFieldState(input.name))} {...rest} />
  );
}

const configToProps = (field, data, defaults = {}) => {
  const validators = [...(field.validators || []), ...(field.required ? [{ type: 'required' }] : [])];
  return {
    parse: (value) => (isEmptyish(value) ? null : value),
    color: 'secondary',
    variant: 'outlined',
    fullWidth: true,
    ...defaults,
    name: field.path,
    component: typeToComponent(field.type),
    ...(validators.length > 0 ? { validate: generateValidator(validators) } : {}),
    ...(['checkbox', 'radio'].includes(field.type) ? { type: field.type } : {}),
    label: miniHandlebars(field.label, data),
    helperText: field.helperText,
    options: field.options,
    ...(field.path === 'user_list_item.app.levelOfInterest' ? {
      marks: new Array(field.options.length).fill().map((x, i) => ({ value: i, label: i + 1 })),
    } : {}),
    ...(field.path === 'user_profile.housing.paymentPreference' ? {
      options: field.options.map((opt, i) => (
        {
          ...opt,
          icon: ([<KeyOutlined />, <ChairOutlined />, <NotListedLocationOutlined />])[i],
        }
      )),
    } : {}),
    ...(field.path === 'user_profile.notifPrefs.Mover.text' ? {
      component: InputController,
      WrappedComponent: typeToComponent(field.type),
      inputController: (input, rffField) => ({
        ...input,
        checked: isSimpleObject(rffField?.value) && Object.values(rffField.value).some((v) => v),
        onChange: (event) => {
          const realValue = {};
          Object.values(NotifPrefs.Mover.text).forEach((pref) => {
            realValue[pref.keys[2]] = event.target.checked;
          });
          input.onChange(realValue);
        },
      }),
    } : {}),
    ...field.fieldProps,
  };
};

export default configToProps;
